import React, { useEffect } from 'react';
import {
  arrayOf,
  params,
  shape,
  string as stringType,
  useDataModel
} from '@thd-nucleus/data-sources';
import { withDynamicComponent } from '@thd-nucleus/app-render';
import { Link, Skeleton, SkeletonBlock, Typography } from '@one-thd/sui-atomic-components';
import { withHydrator } from '@thd-olt-component-react/hydrator';

const NationalDirectoryComponent = () => {
  useEffect(() => {
    if (window.LIFE_CYCLE_EVENT_BUS?.lifeCycle?.trigger) {
      window.LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('store-directory.ready');
    }
  }, []);

  const { data, loading, error } = useDataModel('storeDirectory', {});
  const storeDirectory = data?.storeDirectory?.storeDirectory || [];

  const heading = (
    <section>
      <Typography variant="h1" weight="display">Store Directory</Typography>
    </section>
  );

  if (loading) {
    return (
      <article data-component="NationalDirectoryPlaceholder">
        {heading}
        <Skeleton SkeletonContentProps={{ disablePadding: true }} grow>
          <SkeletonBlock aspect="wide" height="515px" />
        </Skeleton>
      </article>
    );
  }
  if (!storeDirectory?.length || error) return null;

  return (
    <article data-component="NationalDirectory">
      {heading}
      <section className="sui-columns-2 sui-p-4 md:sui-columns-3 lg:sui-columns-6 lg:sui-gap-10">
        {storeDirectory.map(({ stateName, stateLink }, stateIndex) => {
          return (
            <div className="sui-py-1 sui-pb-4 sui-break-inside-avoid" key={`${stateName}-${stateIndex}`}>
              <Link
                underline="none"
                className="sui-font-bold sui-py-1 sui-inline-block"
                id={`${stateName}-${stateIndex}`}
                href={stateLink}
              >
                {stateName}
              </Link>
            </div>
          );
        })}
      </section>
    </article>
  );
};

NationalDirectoryComponent.displayName = 'NationalDirectory';

const dataModel = {
  storeDirectory: params().shape({
    storeDirectory: arrayOf(shape({
      stateName: stringType(),
      stateLink: stringType(),
    }))
  })
};

NationalDirectoryComponent.dataModel = dataModel;

const HydratedComponent = withHydrator({
  delay: 500,
  id: 'national-directory',
  placeholder: (
    <div data-component="NationalDirectoryPlaceholder">
      <Skeleton SkeletonContentProps={{ disablePadding: true }} grow>
        <SkeletonBlock aspect="wide" height="500px" />
      </Skeleton>
    </div>
  ),
  scrollBuffer: 100,
}, NationalDirectoryComponent);

const NationalDirectory = withDynamicComponent(HydratedComponent);

NationalDirectory.dataModel = dataModel;

export { NationalDirectory };
